import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "./CustomButton";

export default function LogoutForm({ updateLogin }) {
    const navigate = useNavigate();

    useEffect(() => {
        if (!window.sessionStorage.getItem("BearerToken"))
            onLogout();
    }, []);

    function onLogout() {
        updateLogin(false);
        window.sessionStorage.clear();
        navigate("/");
    }

    return (
        <div>
            <h1>Logout</h1>
            <p>Are you sure you want to logout?</p>
            <CustomButton type="button" variant="contained" color="primary" onClick={onLogout}>Yes, Logout</CustomButton>
        </div>
    );
}